export default {
    computed: {
        filteredItemsA(){
            return this.items.filter((item) => {
                return item.title.toLowerCase().includes(this.searchString.toLowerCase());
            });
        }
    }
};